export default __webpack_public_path__ + "static/media/newYear2024-little-desktop.506caad0.png";